<template>
  <div class="min-h-screen bg-[#050a30]">
    <NavBarComp />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import NavBarComp from "./components/templates/NavBarComp.vue";
import Footer from "./components/templates/FooterComp.vue";
export default {
  name: "App",
  components: {
    NavBarComp,
    Footer,
  },
};
</script>

<style>
</style>
